import SharedTicketDetailCard from "../../default/components/TicketDetailCard";

const TicketDetailCard = (props) => {
    return <SharedTicketDetailCard variant="hr-support" {...props} />;
};

export default TicketDetailCard;